import {Component, OnInit, ViewChild} from '@angular/core';
import {PromocionesService} from "../../../core/promociones/promociones.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MessageService} from "primeng/components/common/messageservice";
import {Environment} from "../../../core/environment-core";
import {PromocionInfo} from "../../../core/promociones/promocion-info";
import {AddCodesModalComponent} from "./add-codes-modal-component";
import {ActivationModalComponent} from "../quantum/activation-modal-component";
import {PrincipalModalComponent} from "../quantum/principal-modal-component";

declare var $;

@Component({
  selector: 'app-ganalottodo-promotions',
  templateUrl: './ganalottodo-promotions.component.html',
  styleUrls: ['./ganalottodo-promotions.component.scss']
})
export class GanalottodoPromotionsComponent implements OnInit {
  promociones: PromocionInfo[] = [];
  @ViewChild('inputCodes')
  inputCodes: any;
  loading = true;
  loadingCodes = false;
  promotionKey: string;
  promotionType = 'saldosGanalottodo';

  constructor(private promocionesService: PromocionesService,
              private router: Router,
              private modalService: NgbModal,
              private route: ActivatedRoute,
              private messageService: MessageService,
              public environment: Environment) {

    this.route.params.subscribe((param) => {
      console.log('Param: ', param);
      this.promotionType = param.promotionType;
      this.loading = true;
      this.getPromotions();
    });
  }

  ngOnInit() {
  }

  open(promocion) {
    const modalRef = this.modalService.open(ActivationModalComponent, {backdrop: 'static'});
    modalRef.componentInstance.promocion = promocion;
    modalRef.result.then((result) => {
      // this.closeResult = `Closed with: ${result}`;
      console.log(result);
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      console.log(reason);
    });
  }

  openAddCodes(promocion) {
    const modalRef = this.modalService.open(AddCodesModalComponent, {backdrop: 'static'});
    modalRef.componentInstance.promocion = promocion;
    modalRef.result.then((result) => {
      // this.closeResult = `Closed with: ${result}`;
      console.log(result);
      this.getPromotions();
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      console.log(reason);
    });
  }

  downloadErrorCodes(promotionKey) {
    this.promocionesService.downloadErrorCodes(promotionKey).subscribe((data) => {
      console.log('promotion key, descarga de codigo de error');
      console.log(promotionKey);
      this.downloadFile(data, promotionKey);
    }, (error) => {
      console.log("Error downloading the file");
    });
  }

  downloadFile(blob, promotionKey) {
    const url = window.URL.createObjectURL(blob);
    const anchorElem = document.createElement("a");
    anchorElem.style.display = "none";
    anchorElem.href = url;
    anchorElem.download = `${promotionKey}-codes-error.csv`;

    document.body.appendChild(anchorElem);
    anchorElem.click();

    document.body.removeChild(anchorElem);

    // On Edge, revokeObjectURL should be called only after
    // a.click() has completed, atleast on EdgeHTML 15.15048
    setTimeout(function () {
      window.URL.revokeObjectURL(url);
    }, 1000);
  }

  addPromotion() {
    this.router.navigate(['/ganalottodo/ganalottodo-promotion/new']);
  }

  editPromotion(key: string) {
    this.router.navigate(['/ganalottodo/ganalottodo-promotion/' + key]);
  }

  openPrincipalModal(promocion: PromocionInfo) {
    const modalRef = this.modalService.open(PrincipalModalComponent, {backdrop: 'static'});
    modalRef.componentInstance.promocion = promocion;
    modalRef.componentInstance.promociones = this.promociones;
    modalRef.result.then((result) => {
      console.log(result);
    }, (reason) => {
      console.log(reason);
    });
  }

  showDetails(promocion: PromocionInfo) {
    // this.router.navigate([promocion.promotionKey], {relativeTo: this.route});
    this.router.navigate(['/ganalottodo/promotions/' + this.promotionType + '/' + promocion.promotionKey]);
  }

  upFile(inputid, promotionKey) {
    this.promotionKey = promotionKey;
    $("#" + inputid).prop('type', 'file');
    $("#" + inputid).trigger('click');
  }

  fileCodesUpload(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      if (file.size > 0) {
        console.log('File Size');
        console.log(file.size);
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('promotionKey', this.promotionKey);
        console.log('PromocionesComponent#fileCodesUpload:fileName');
        console.log(file.name);
        console.log(formData.get('file'));
        this.uploadCodes(formData);
      } else {
        this.messageService.add({
          severity: 'error',
          summary: '',
          detail: 'Archivo de codigos vacio'
        });
      }
    }
    this.inputCodes.nativeElement.value = "";
  }

  uploadCodes(formData) {
    console.log('PromocionesComponent#uploadCodes');
    console.log(formData.get('file'));
    this.loadingCodes = true;
    this.promocionesService.uploadCodesPromotion(formData).subscribe(
      (code) => {
        this.loadingCodes = false;
        this.messageService.add({
          severity: 'success',
          summary: '',
          detail: 'Se cargaron codigos correctamente'
        });
      },
      (err) => {
        this.loadingCodes = false;
        console.log('PromocionesComponent#uploadCodes:error');
        console.log(err);
        this.processError(err.error);
      });
  }

  processError(error) {
    switch (error) {
      case 'CodesAlreadyExist':
        this.messageService.add({
          severity: 'error',
          summary: '',
          detail: 'Algunos códigos ya encuentran registrados. Verifique e intente de nuevo'
        });
        break;
      default:
        this.messageService.add({
          severity: 'error',
          summary: '',
          detail: 'Ocurrio un error en la carga de códigos'
        });
    }
  }

  getPromotions() {
    this.promocionesService.getPromociones(this.promotionType).subscribe((promociones) => {
      this.promociones = promociones;
      console.log('Mostramos las promociones', this.promociones);
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/promociones/ganalottodo/ganalottodo-promotions.component.ts